import { PAI_STATES } from "../post-inspection-diy/constant";

export const SCREEN_TYPES = {
    "NO_BID": "NO_BID",
    "AUCTION_OVER": "AUCTION_OVER",
    "NON_SO_GS_OFFER": "NON_SO_GS_OFFER",
    "PRICE_DECREASE": "PRICE_DECREASE",
    "PRICE_INCREASE": "PRICE_INCREASE",
    "SO_TO_NON_GS": "SO_TO_NON_GS",
    "PRICE_EXPIRED": "PRICE_EXPIRED",
    "NO_BID_AFTER_REAUCTION": "NO_BID_AFTER_REAUCTION",
    "GS_AUCTION": "GS_AUCTION",
    "DEALER_BACK_OUT": "DEALER_BACK_OUT"
};

const screenContentMapping = {
    [SCREEN_TYPES.GS_AUCTION]: {
        title: "Congratulations! Your car got selected for an exclusive offer"
    },
    [SCREEN_TYPES.PRICE_EXPIRED]: {
        title: "Sorry! We couldn’t get you a good price"
    },
    [SCREEN_TYPES.NO_BID]: {
        title: "Sorry! We couldn’t get you a good price"
    },
    [SCREEN_TYPES.DEALER_BACK_OUT]: {
        title: "Unfortunately, your price got expired as our channel partner opted out"
    },
    [SCREEN_TYPES.NO_BID_AFTER_REAUCTION]: {
        title: "Sorry! We couldn’t get you an offer for your car"
    },
    [SCREEN_TYPES.AUCTION_OVER]: {
        title: "Exciting update! We got an offer for your car",
        isPageViewGa: true,
        eventDetails: {
            gaEventName: "Price view with HI price",
            eventCategory: "DIY_Price"
        }
    },
    [PAI_STATES.PAI_PRICE_RECEIVED]: {
        title: "Great news! We got the price you wanted",
        isPageViewGa: true,
        eventDetails: {
            gaEventName: "PAI/OCB price page view",
            eventCategory: "DIY_Price_nego"
        }
    },
    [PAI_STATES.PAI_DNP_PRICE]: {
        title: "Great news! We got a price closer to your expectation",
        isPageViewGa: true,
        eventDetails: {
            gaEventName: "PAI/OCB DNP price page view",
            eventCategory: "DIY_Price_nego"
        }
    }
};

// eslint-disable-next-line complexity
export const getScreenContent = ({isExpired, isNoBid, isPostLeadLost, paiState, isReAuction, isGsAssuredPrice = false, isDealerBackOut = false}) => {
    if (isPostLeadLost || isExpired) return screenContentMapping[SCREEN_TYPES.PRICE_EXPIRED];
    if (isNoBid) {
        if (isDealerBackOut) return screenContentMapping[SCREEN_TYPES.DEALER_BACK_OUT];
        if (isReAuction) return screenContentMapping[SCREEN_TYPES.NO_BID_AFTER_REAUCTION];
        return screenContentMapping[SCREEN_TYPES.NO_BID];
    }
    if (isGsAssuredPrice) return screenContentMapping[SCREEN_TYPES.GS_AUCTION];
    if (paiState === PAI_STATES.PAI_PRICE_RECEIVED) return screenContentMapping[PAI_STATES.PAI_PRICE_RECEIVED];
    if (paiState === PAI_STATES.PAI_DNP_PRICE) return screenContentMapping[PAI_STATES.PAI_DNP_PRICE];
    return screenContentMapping[SCREEN_TYPES.AUCTION_OVER];
};

export const isTokenStepActive = ({assuredPriceFlag, paiState}) => {
    return  assuredPriceFlag ||
            paiState === PAI_STATES.PAI_PRICE_RECEIVED ||
            paiState === PAI_STATES.PAI_DNP_PRICE;
};
